import { margin, rem } from 'polished'
import { styled } from 'styles/stitches.config'
import { Grid as GridChakra } from '@chakra-ui/react'

import ButtonComponent from 'components/Button'

export const Map = styled('div', {
  width: '100%',
  height: 200,
  marginBottom: 50,

  background: '#A7C2B9',

  '@lg': {
    height: 350,
    marginBottom: 112,
  },
})

export const Flex = styled('div', {
  '@lg': {
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
  },
})

export const Left = styled('div', {
  flex: 1,
  marginBottom: 50,

  '@lg': {
    marginBottom: 0,
  },
})

export const Form = styled('form', {
  marginTop: 15,

  '@md': {
    marginTop: 32,
  },
})

export const Grid = styled(GridChakra, {
  gridTemplateColumns: 'repeat(1, 1fr)',

  '@md': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
})

export const Right = styled('aside', {
  flex: 1,

  '@lg': {
    marginLeft: 94,
    maxWidth: 400,
  },
})

export const Button = styled(ButtonComponent, {
  position: 'relative',

  marginTop: 56,

  '& svg': {
    marginLeft: 5,
    marginTop: '-2px',
  },
})

export const About = styled('div', {
  padding: 16,
  position: 'sticky',
  top: 10,
  borderRadius: 4,
  maxWidth: '100% !important',

  '@lg': {
    padding: 48,
  },

  '& h4': {
    fontSize: '28px !important',
    marginBottom: 40,
  },
})

export const Item = styled('div', {
  display: 'flex',
  alignItems: 'center',

  '&:not(:last-of-type)': {
    paddingBottom: 35,
    marginBottom: 35,
    borderBottom: 'solid 1px',
    borderBottomColor: '$emerald500',
  },
})

export const IconWrap = styled('div', {
  width: 60,
  height: 60,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 10,

  borderRadius: '100%',
  background: '$emerald100',
})

export const Label = styled('p', {
  fontFamily: '$domine',
  fontWeight: 'bold',
  fontSize: rem(14),
  color: '$grey900',
})

export const Text = styled('p', {
  fontFamily: '$domine',
  fontSize: rem(14),
  color: '$grey600',
  marginLeft: 'auto',
})

export const TableContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: rem(22),
})

export const TextContent = styled('p', {
  fontFamily: '$domine',
  fontSize: rem(14),
  color: '$grey600',
  marginBottom: rem(22),
})

export const TextLink = styled('a', {
  fontFamily: '$domine',
  fontSize: rem(14),
  color: '$grey600',
  textDecoration: 'underline',
})

export const Title = styled('h2', {
  fontSize: '37px !important',
  marginTop: rem(22),
  marginBottom: rem(22),
})

export const Table = styled('table', {
  borderCollapse: 'collapse',
})

export const TableTh = styled('th', {
  backgroundColor: '#f2f2f2',
  border: '1px solid #ddd',
  padding: rem(8),
})

export const TableTd = styled('td', {
  border: '1px solid #ddd',
  padding: '8px',
})

export const TableTr = styled('tr', {
  textAlign: 'center',
})

export const WrapperItemList = styled('div', {
  maxWidth: '80%',
  margin: '0 auto',
})

export const ItemList = styled('div', {
  padding: '15px',
  backgroundColor: '$grey100',
  borderRadius: '8px',
  marginBottom: '10px',
  color: '$black',
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.5,
  },
})

export const ImageContainer = styled('figure', {
  position: 'relative',

  width: "80%",
  height: 250,
  marginBottom: 22,

  margin: ' auto',
  border: '4px solid $white ',
  boxShadow: '0 0 8px rgba(0, 0, 0, 0.6)',

  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  "@md" : {
    width: 550,
  height: 350,
  marginBottom: 22,
  }
})
